import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import { useSelector } from "../../../components/hooks/hooks";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import {
    FiCheckCircle,
    FiClock,
    FiPlusCircle,
    FiXCircle,
} from "react-icons/fi";
import { FcHighPriority } from "react-icons/fc";
import { ToastContainer } from "react-toastify";
import { backendApi } from "../../../api/apiService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
export default function AgeingReport() {
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.login);
    console.log("🚀 ~ userDetails:", userDetails);
    const [menuClick, setMenuClick] = useState(false);
    const [vacancyReport, setVacancyReport] = useState([]);
    const [Departments, setDepartments] = useState([]);

    useEffect(() => {
        getSchedulRerecruitmentReports();
    }, []);
    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };
    const getSchedulRerecruitmentReports = () => {
        const api = {
            functionName: "ageingReport",
            site_id: userDetails[0].site_id,
            is_active: "1"
        };
        backendApi(api).then((response) => {
            if (response.success === 1) {
                console.log(response, "ageingReport");
                setVacancyReport(response.dataSet);
                setDepartments(response.department);
            }
            console.log("🚀 ~ backendApi ~ response:", response);
        });
    };
    const handleBack = () => {
        navigate('/dashboard/analytics-dashboard');
    };
    return (
      
                <div className="main-container">
                    <ToastContainer
                        enableMultiContainer
                        containerId={"D"}
                        position="bottom-right"
                        autoClose={1500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                    />
                    <div className="card main-card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xxl-12 col-lg-12 col-md-6 padding-left-right-change">
                                    <div className="card main-card-box">
                                        {/* <div class="form-group col-6 dflexClm offset-6">
                                            <label class="form-label">Departments</label>
                                            <select class="form-control">
                                                <option value="">-Select-</option>
                                                {Departments.map((department) => (
                                                    <option key={department.id} value={department.departmentOrProject}>
                                                        {department.departmentOrProject}
                                                    </option>
                                                ))}
                                            </select>
                                        </div> */}

                                        <div className="card-body">
                                            {/* <h4 className="dash-sub-head">Ageing Report</h4> */}
                                            <div className="table-responsive">
                                                <table className="table mb-0">
                                                    <thead>

                                                        <tr>
                                                            <th style={{ width: "80px" }}>ID</th>
                                                            <th style={{ width: "80px" }}>Summary</th>

                                                            <th style={{ width: "80px" }}>No. of Positions</th>
                                                            <th style={{ width: "80px" }}>Start Date</th>
                                                            <th style={{ width: "80px" }}>End Date</th>
                                                            <th style={{ width: "80px" }}>Ageing</th>
                                                            <th style={{ width: "80px" }}>Job Type</th>
                                                            <th style={{ width: "80px" }}>Status</th>
                                                            {/* <th style={{ width: "80px" }}>Location</th> */}
                                                            {/* <th style={{ width: "80px" }}>Salary</th> */}
                                                            {/* <th style={{ width: "80px" }}>Notice Period</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {vacancyReport.length > 0 ? (
                                                            <>
                                                                {vacancyReport.map((job, index) => {
                                                                    return (
                                                                        <tr key={job.id}>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{index + 1}</td>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{job.summary}</td>

                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{job.no_of_position}</td>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{new Date(job.start_date).toLocaleDateString()}</td>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{new Date(job.end_date).toLocaleDateString()}</td>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{job.pendingdays}</td>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>{job.job_type}</td>
                                                                            <td style={{
                                                                                color: job.pendingdays < 0 ? "red" : "green",
                                                                            }}>
                                                                                {job.recStatus && job.recStatus.length > 0 ? (
                                                                                    job.recStatus.map((status, idx) => (
                                                                                        <div key={idx}>{status.status_name} <b>({status.cnt})</b></div>
                                                                                    ))
                                                                                ) : (
                                                                                    <div>No Status</div>
                                                                                )}
                                                                            </td>
                                                                            {/* <td>{job.location}</td>
                                                                            <td>{job.salary || 'N/A'}</td>
                                                                            <td>{job.notice_period}</td> */}
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </>
                                                        ) : (
                                                            <p>No Openings found</p>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="floating-back-button"
                        onClick={handleBack}
                    >
                        <BsArrowLeftCircleFill size={24} />
                    </button>
                </div>
           
    );
}
